<template>
    <div class="form-group mb-3">
        <input
            class="form-control pl-4"
            type="text"
            v-model="inputValue"
            @input="updateField"
        />
    </div>
</template>

<script>

export default {
    name: 'TextField',
    props: {
        propsValue: String,
    },
    data() {
        return {
            inputValue: null
        }
    },
    methods: {
        updateField() {
            this.$emit('update-content', this.inputValue)
        }
    },
    mounted() {
        if (this.propsValue) {
            this.inputValue = this.propsValue
        }
    }
}

</script>

<style scoped>

</style>
